import './SurveyQuestionCreateModal.less'

import { ButtonClean } from 'front-end/src/components'
import React, { useContext } from 'react'

import { Trans } from '@lingui/macro' // TODO figure out why lingui Trans is throwing errors on render just in this file

import { SurveyQuestionTypes } from '../../../../../../shared/surveys'
import HorizontalChoiceSelector from '../../../../components/common/horizontal-choice-selector/HorizontalChoiceSelector'
import { Modal } from '../../../../components/common/modal/Modal'
import { getSurveyTypeImage } from '../../helpers'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { useCreateQuestionMutation } from '../send/surveysOperations.codegen'

interface IProps {
  isShown: boolean
  hide: () => void
  onCreate: (id: number) => void
}

export default (props: IProps) => {
  const { isShown, hide } = props
  const { survey, refetchSurvey } = useContext(ManageSurveyContext)

  const [createQuestion] = useCreateQuestionMutation()

  const onQuestionTypeChoose = async (questionType) => {
    const { data } = await createQuestion({
      variables: {
        surveyId: survey.id,
        input: {
          type: questionType,
          title: ''
        }
      }
    })

    if (data && data.admin.survey.createQuestion) {
      hide()
      await refetchSurvey()
    }
  }

  return (
    <Modal
      className="SurveyQuestionCreateModal"
      header={<Trans>Select a question type to add:</Trans>}
      show={isShown}
      onHide={hide}
      controls={[
        <ButtonClean key={1} onClick={hide}>
          <Trans>Close</Trans>
        </ButtonClean>
      ]}
    >
      <HorizontalChoiceSelector
        colorScheme="light-gray"
        name="type"
        onChange={(val) => {
          onQuestionTypeChoose(val)
        }}
        options={[...questionOptionButtons]}
      />
    </Modal>
  )
}

const questionOptionButtons = [
  {
    value: SurveyQuestionTypes.BOOL,
    header: (
      <>
        <img
          src={getSurveyTypeImage(SurveyQuestionTypes.BOOL)}
          alt={SurveyQuestionTypes.BOOL}
        />
        <Trans>True</Trans>/<Trans>False</Trans>
      </>
    ),
    description: (
      <div className="ChoiceDescription">
        <Trans>Agree/disagree with a statement</Trans>
      </div>
    )
  },
  {
    value: SurveyQuestionTypes.CHOOSE_ONE,
    header: (
      <>
        <img
          src={getSurveyTypeImage(SurveyQuestionTypes.CHOOSE_ONE)}
          alt={SurveyQuestionTypes.CHOOSE_ONE}
        />
        <Trans>Single-choice</Trans>
      </>
    ),
    description: (
      <div className="ChoiceDescription">
        <Trans>Select one option from a list</Trans>
      </div>
    )
  },
  {
    value: SurveyQuestionTypes.MULTIPLE_CHOICE,
    header: (
      <>
        <img
          src={getSurveyTypeImage(SurveyQuestionTypes.MULTIPLE_CHOICE)}
          alt={SurveyQuestionTypes.MULTIPLE_CHOICE}
        />
        <Trans>Multi-choice</Trans>
      </>
    ),
    description: (
      <div className="ChoiceDescription">
        <Trans>Select one or more options from a list</Trans>
      </div>
    )
  },
  {
    value: SurveyQuestionTypes.RATING,
    header: (
      <>
        <img
          src={getSurveyTypeImage(SurveyQuestionTypes.RATING)}
          alt={SurveyQuestionTypes.RATING}
        />
        <Trans>Range</Trans>
      </>
    ),
    description: (
      <div className="ChoiceDescription">
        <Trans>Select a position within a range</Trans>
      </div>
    )
  },
  {
    value: SurveyQuestionTypes.TEXT,
    header: (
      <>
        <img
          src={getSurveyTypeImage(SurveyQuestionTypes.TEXT)}
          alt={SurveyQuestionTypes.TEXT}
        />
        <Trans>Text</Trans>
      </>
    ),
    description: (
      <div className="ChoiceDescription">
        <Trans>Write a response into a text field</Trans>
      </div>
    )
  },
  {
    value: SurveyQuestionTypes.INFO,
    header: (
      <>
        <img
          src={getSurveyTypeImage(SurveyQuestionTypes.INFO)}
          alt={SurveyQuestionTypes.INFO}
        />
        <Trans>Information</Trans>
      </>
    ),
    description: (
      <div className="ChoiceDescription">
        <Trans>No question - just information for the recipient</Trans>
      </div>
    )
  }
]
